import { MaskedLines, Reveal } from "./Motion";

export const PageHero = ({ overline, titleLines, subtitle }) => (
  <section className="border-b border-border pt-36 pb-16 lg:pt-44 lg:pb-24">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <Reveal>
        <span className="overline text-accent">{overline}</span>
      </Reveal>
      <MaskedLines
        el="h1"
        lines={titleLines}
        delay={0.1}
        className="mt-6 max-w-4xl font-serif text-5xl font-light leading-[0.95] tracking-tight text-foreground sm:text-6xl lg:text-7xl"
      />
      {subtitle && (
        <Reveal delay={0.4}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">{subtitle}</p>
        </Reveal>
      )}
    </div>
  </section>
);
